<template>
  <div class="upsell pu_bottom popup_click_hide">
    <div class="pu_bottom_scroll">
      <div class="pu_b_close" @click="close()"></div>
      <div class="pu_bottom_inner scroll_y">
        <div v-if="text('upsell_header')" class="pu_tovar_name"
             style="font-size: 18px;padding-top: 20px;text-align: center;">
          {{text('upsell_header')}}
        </div>
        <div class="upsell-items">
          <div class="pu_tovar" v-for="product in $store.getters.upsell">
            <div style="display: flex; justify-content: space-between;">
              <div>
                <div class="pu_tovar_name" style="font-size: 16px;">
                  {{product.name}} <span>{{ product.qty }}&nbsp;{{ product.qty_unit }}</span></div>
                <div class="pu_tovar_text" :class="{'ios-font': $store.getters.checkIos}">{{$options.filters.toCurrency(product.price)}}</div>
              </div>
              <div style="display:flex;">
                            <span class="plus-minus">
                            <input type="text" name="count" :value="product.count">
                            <a class="cart__count-down" @click="changeCount(-1, product)">
                              <svg width="12" height="2" viewBox="0 0 12 2" fill="none"
                                   xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M0 1C0 0.447715 0.447715 0 1 0H11C11.5523 0 12 0.447715 12 1C12 1.55228 11.5523 2 11 2H1C0.447715 2 0 1.55228 0 1Z"
                                  fill="#1A1A1B"/>
                              </svg>
                            </a>
                            <a
                              :class="{'disable': product.disableQty && product.count >= product.disableQty}"
                              class="cart__count-up"
                              @click="changeCount(1, product)"
                            >
                              <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                   xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M6 0C5.44772 0 5 0.447715 5 1V5H1C0.447715 5 0 5.44772 0 6C0 6.55228 0.447715 7 1 7H5V11C5 11.5523 5.44772 12 6 12C6.55228 12 7 11.5523 7 11V7H11C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5H7V1C7 0.447715 6.55228 0 6 0Z"
                                      fill="#1A1A1B"/>
                              </svg>
                            </a>
                          </span>
              </div>
            </div>
          </div>
        </div>

        <div class="pu_tovar_nav">
          <div class="pu_tovar_nav_btn nav_btn_upsell">
            <a
              class="upsell-btn fbb_btn upsell-btn__yes"
              :class="{'upsell-btn__disable': isEmpty}"
              @click="addAndNext()"
            >
              <template>{{text('upsell_yes')}}</template>
            </a>
            <a
              class="upsell-btn fbb_btn upsell-btn__no"
              @click="skipAndNext()"
            >
              <template>{{text('upsell_no')}}</template>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {SET_MODAL, SET_UPSELL_ITEM_COUNT} from '@/store/mutations.type'
  import {ADD_UPSELL_TO_BASKET, MAKE_ORDER} from '@/store/actions.type'

  export default {
    name: 'Upsell',
    data() {
      return {
        IMAGE_TYPE_ORIGINAL: 0,
        IMAGE_TYPE_SPLASH: 1,
        IMAGE_TYPE_SPLASH_2X: 2,
        IMAGE_TYPE_LARGE: 3
      }
    },
    methods: {
      async addAndNext() {
        if (!this.isEmpty) {
          await this.$store.dispatch(ADD_UPSELL_TO_BASKET)
          for (let i in this.$store.getters.upsell) {
            this.$store.commit(SET_UPSELL_ITEM_COUNT, {id: this.$store.getters.upsell[i].id, data: 0})
          }
        }
        if (
          this.$store.getters.enableOrder &&
          this.$store.getters.contactlessMode &&
          !this.$store.getters.enableOnlinePayment
        ) {
          this.$store.dispatch(MAKE_ORDER, {})
        } else {
          this.$router.push({name: 'form', params: {token: this.$store.getters.token}})
        }
        return this.close()
      },
      skipAndNext() {
        if (
          this.$store.getters.enableOrder &&
          this.$store.getters.contactlessMode &&
          !this.$store.getters.enableOnlinePayment
        ) {
          this.$store.dispatch(MAKE_ORDER, {})
        } else {
          this.$router.push({name: 'form', params: {token: this.$store.getters.token}})
        }
        return this.close()
      },
      changeCount(value, product) {
        if (product.count + value < 0) {
          return
        }
        this.$store.commit(SET_UPSELL_ITEM_COUNT, {id: product.id, data: product.count + value})
      },

      close() {
        this.$store.commit(SET_MODAL, {modal: 'upsell', status: false})
      },

      setHeight(event) {
        let image = event.target
        image.height = image.clientWidth
      },

      getImageUrl(product, type) {
        let params = ''

        if (type === this.IMAGE_TYPE_ORIGINAL) {
          return product.images[0].original + params
        }
        if (type === this.IMAGE_TYPE_SPLASH) {
          return product.images[0].splash + params
        }
        if (type === this.IMAGE_TYPE_SPLASH_2X) {
          return product.images[0].splash_2x + params
        }
        if (type === this.IMAGE_TYPE_LARGE) {
          return product.images[0].large + params
        }
      }
    },
    computed: {
      isEmpty() {
        for (let i in this.$store.getters.upsell) {
          if (this.$store.getters.upsell[i].count > 0) {
            return false
          }
        }
        return true
      }
    }
  }
</script>

<style scoped>
  .upsell .pu_tovar {
    padding-bottom: 0;
  }

  .upsell .upsell-items .pu_tovar:last-child {
    padding-bottom: 90px;
  }

  .upsell .upsell-btn {
    padding-left: 0;
    text-align: center;
    cursor: pointer;
  }

  .cart__count-up.disable {
    pointer-events: none;
    cursor: default;
  }

  .cart__count-up.disable svg path {
    fill: #ccc;
  }
</style>
